import { getProgramIdentifier, getProgramIdFromUrl } from "../utils"
import { RootState } from "./rootReducer"
import { VerifyResponse } from '../components/success/SuccessStage'

export const loadState = (): RootState | undefined => {
    try {
        const serializedState = localStorage.getItem(`reduxState_${getProgramIdentifier()}`)
        if (serializedState === null) {
            return undefined // No saved state, so let reducers initialize the state
        }
        const parsedSerializedState = JSON.parse(serializedState) as RootState

        //sanity check if program_id matches the saved id
        if(getProgramIdFromUrl() !== parsedSerializedState?.program.data.id) {
            return undefined
        }

        const participantHasData = Object.keys(parsedSerializedState.participant.data).length > 0
        const hasRegistrations = parsedSerializedState.registrations.list.length > 0
        if( participantHasData || hasRegistrations) {
            parsedSerializedState.misc.isRestoredData = true
        }else {
            parsedSerializedState.misc.isRestoredData = false
        }
        
        // Always reset successfulResponse when loading state to prevent old responses from persisting
        parsedSerializedState.misc.successfulResponse = {} as VerifyResponse
        
        return parsedSerializedState
    } catch (err) {
        console.error('Could not load state', err)
        return undefined
    }
}

export const saveState = (state: RootState): void => {
    try {
        const serializedState = JSON.stringify(state)
        localStorage.setItem(`reduxState_${getProgramIdentifier()}`, serializedState)
    } catch (err) {
        console.error('Could not save state', err)
    }
}

export const deleteState = (): void => {
    localStorage.removeItem(`reduxState_${getProgramIdentifier()}`)
    localStorage.removeItem(`lastVisitedRoute_${getProgramIdentifier()}`)
}

export const deleteLastVisitedRoute = (): void => {
    localStorage.removeItem(`lastVisitedRoute_${getProgramIdentifier()}`)
}